<app-posts type="Professional"></app-posts>